import { post } from '..';

const addUserGroup = (Name: string, Description: string, Members) => post(
  'users/v2/user-groups',
  { Name, Description, Members },
);

export default addUserGroup;
